import React from "react";
import { Link, NavLink } from "react-router-dom";
import { LogOut, Inbox, FileEdit, ShieldCheck } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export default function AdminTopbar() {
  const { user, logout } = useAuth();
  const linkBase =
    "inline-flex items-center gap-2 px-3 py-1.5 rounded-full font-mono text-[10px] uppercase tracking-[0.22em] border-2 transition-colors";

  return (
    <header className="bg-[#0A0A0A] text-[#FAF5E8] sticky top-0 z-30">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8 h-14 flex items-center justify-between gap-4">
        <Link to="/admin" className="flex items-center gap-3 shrink-0">
          <span className="font-display text-2xl tracking-tight">R⋆TAMA</span>
          <span className="hidden sm:inline font-mono text-[10px] uppercase tracking-[0.25em] text-[#FAF5E8]/60">
            Admin
          </span>
        </Link>

        <nav className="flex items-center gap-2" data-testid="admin-tabs">
          <NavLink
            to="/admin"
            end
            data-testid="admin-tab-inbox"
            className={({ isActive }) =>
              `${linkBase} ${
                isActive
                  ? "bg-[#FFD500] text-[#0A0A0A] border-[#FFD500]"
                  : "border-[#FAF5E8]/30 text-[#FAF5E8]/80 hover:border-[#FAF5E8]"
              }`
            }
          >
            <Inbox className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">Inbox</span>
          </NavLink>
          <NavLink
            to="/admin/content"
            data-testid="admin-tab-content"
            className={({ isActive }) =>
              `${linkBase} ${
                isActive
                  ? "bg-[#FFD500] text-[#0A0A0A] border-[#FFD500]"
                  : "border-[#FAF5E8]/30 text-[#FAF5E8]/80 hover:border-[#FAF5E8]"
              }`
            }
          >
            <FileEdit className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">Content</span>
          </NavLink>
          <NavLink
            to="/admin/activity"
            data-testid="admin-tab-activity"
            className={({ isActive }) =>
              `${linkBase} ${
                isActive
                  ? "bg-[#FFD500] text-[#0A0A0A] border-[#FFD500]"
                  : "border-[#FAF5E8]/30 text-[#FAF5E8]/80 hover:border-[#FAF5E8]"
              }`
            }
          >
            <ShieldCheck className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">Activity</span>
          </NavLink>
        </nav>

        <div className="flex items-center gap-3 shrink-0">
          <span
            data-testid="admin-current-user"
            className="hidden md:inline font-mono text-[10px] uppercase tracking-[0.25em] text-[#FAF5E8]/70"
          >
            {user?.email}
          </span>
          <button
            data-testid="admin-logout"
            onClick={logout}
            className="inline-flex items-center gap-2 bg-[#FF2D9C] text-[#FAF5E8] px-3 py-1.5 rounded-full font-mono text-[10px] uppercase tracking-[0.22em] hover:bg-[#FAF5E8] hover:text-[#0A0A0A] transition-colors"
          >
            <LogOut className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">Sign out</span>
          </button>
        </div>
      </div>
    </header>
  );
}
